import { GatsbyImageData } from "wmk-image";
import {  Tag } from "wmk-tag";
import { FlickrFields } from "../../../../node/fragments/NodeFlickrFields";
import { YouTubeFields } from "../../../../node/fragments/NodeYouTubeFields";
import { startCase } from "lodash";
import { slugify } from "../../../routes/Home/NewsAndEvents/NewsFeed/PostTag";

export interface MediaQuery {
  videos?: { edges: { node: YouTubeFields }[] };
  photos?: { edges: { node: FlickrFields }[] };
}

export type MediaItem = MediaVideo | MediaPhoto;

export class Media {
  list: (MediaVideo | MediaPhoto)[];
  videos: MediaVideo[];
  photos: MediaPhoto[];
  length: number;
  constructor(query: MediaQuery) {
    const vidArray: MediaVideo[] = [];
    const picArray: MediaPhoto[] = [];
    const videos = Array.isArray(query?.videos?.edges)
      ? query.videos.edges
          .map((n) => new MediaVideo(n.node))
          .reduce((vids, vid) => {
            if (vid.tags.length > 0) {
              vids.push(vid);
            }
            return vids;
          }, vidArray)
      : [];
    const photos = Array.isArray(query?.photos?.edges)
      ? query.photos.edges
          .map((n) => new MediaPhoto(n.node))
          .reduce((pics, pic) => {
            if (pic.tags.length > 0) {
              pics.push(pic);
            }
            return pics;
          }, picArray)
      : [];
    const list = [...videos, ...photos];
    this.length = list.length;
    this.videos = videos;
    this.list = list;
    this.photos = photos;
  }
}

export class MediaPhoto {
  title: string;
  url: string;
  description: string;
  tags: Tag[];
  date: Date;
  uid: string;
  type: "photos";
  thumb: string;
  constructor(node: FlickrFields) {
    this.title = node.title;
    this.url = node.url_o || node.url_l || node.url_c || node.url_m;
    this.thumb =
      node.url_z ||
      node.url_s ||
      node.url_n ||
      node.url_t ||
      node.url_q ||
      node.url_sq;
    this.description = node.description;
    this.tags = getHashtags(node.description);
    this.date = new Date(node.date);
    this.uid = node.photo_id;
    this.type = "photos";
  }
}

export class MediaVideo {
  uid: string;
  title: string;
  description: string;
  image?: GatsbyImageData;
  date: Date;
  tags: Tag[];
  type: "videos";
  constructor(node: YouTubeFields) {
    this.uid = node.videoId;
    this.title = node.title;
    this.description = node.description;
    this.tags = getHashtags(node.description);
    this.image = node.localThumbnail?.childImageSharp?.gatsbyImageData;
    this.date = new Date(node.publishedAt);
    this.type = "videos";
  }
}

const getHashtags = (desc: string) => {
  const hashes = desc.match(/#\w+/g);
  return Array.isArray(hashes)
    ? hashes.map(
        (h) => new Tag({ name: startCase(h), slug: slugify(startCase(h)) })
      )
    : [];
};
